'use client';

import { Image } from '@/components/client';
import { getStaticCdnUrl } from '@/utils';

const GiftPromoSection = () => {
  return (
    <section className="flex w-full flex-col items-center gap-64 py-120 mobile:gap-32 mobile:py-60">
      {/* 타이틀 */}
      <div className="text-center font-800 typo-h2 mobile:font-700 mobile:typo-h5">
        <p className="text-Gray-black">기부금에 따라</p>
        <p>
          <span className="text-O-500">지역 프리미엄 답례품</span>
          <span className="text-Gray-black">을 드려요!</span>
        </p>
      </div>

      {/* 폰 목업 */}
      <div className="relative h-[966px] w-[500px] overflow-hidden mobile:h-[483px] mobile:w-250">
        <Image
          src={getStaticCdnUrl('/donation/guide-gift.png')}
          alt="답례품 목록 예시 화면"
          fill
          sizes="(max-width: 850px) 250px, 500px"
          className="object-contain"
        />
      </div>
    </section>
  );
};

export default GiftPromoSection;
